import { cloneDeep } from 'lodash'

import { proxy } from '@/utils'

import { core } from '@/components/services/settingsSite/utils'

import render from './render'

export default function(options) {
  return {
    mixins: [ proxy({ type: 'object' }), core(options) ],

    data() {
      return {
        passwordVisibility: true
      }
    },

    computed: {
      commonFieldsProps() {
        return {
          disabled: this.loading,
          dense: true,
          clearable: true,
          details: false
        }
      }
    },

    methods: {
      _inputFilter(value) {
        return cloneDeep(value)
      }
    },

    render(h) {
      return render.call(this, h, options)
    }
  }
}
